<template>
  <div>
    <slot name="signBlockList"></slot>
    <div class="canvasContainerCss" :ref="'canvasContainer'"></div>
  </div>

</template>
<script>
import { getCookie } from '@/utils'
import * as pdfjsLib from 'pdfjs-dist'
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry'
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker

const CSS_UNITS = 96.0 / 72.0 // --螢幕解析與列印解析的轉換比率

export default {
  name: 'pdf-viewer-with-image',
  props: {
    src: String,
    base64Data: String,
    cfgRatio: {
      type: String,
      default: '1'
    },
    usedMaskLoading: { // 旗標設，是否於讀取PDF 過程中提供等候畫面遮罩
      type: Boolean,
      default: false
    },
    stretch: { // 是否要延展100%
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      pdfDoc: null,
      pageNum: 1,
      scale: 1,
      numPages: 0,
      lastFinishUrl: '',
      baseUrl: this.$api.defaults.baseURL
    }
  },
  watch: {
    src: {
      handler (src) {
        if (src) {
          src = this.baseUrl + '/' + src
          src && this.fetchPDF(src)
        }
      },
      immediate: true
    },
    base64Data: {
      handler (v) {
        v && this.fetchPDFb64(v)
      },
      immediate: true
    }
  },

  methods: {
    startLoading () {
      this.$store.commit('START')
    },
    endLoading () {
      // this.$store.commit('END')
      let vm = this
      vm.$nextTick(() => {
        setTimeout(() => {
          vm.$store.commit('END')
        }, 1000)
      })
    },
    fetchPDF (src) {
      const vm = this
      if (src && src.indexOf('transCode=_blank') > -1) {
        return
      } else if (src === this.lastFinishUrl) {
        return
      }
      if (vm.usedMaskLoading) { // 透過旗標決定是否要有等候遮罩畫面
        vm.startLoading()
      }
      let xsrft = getCookie('!Proxy!RestApiProxyXSRF-TOKEN')
      if (!xsrft) {
        xsrft = getCookie('XSRF-TOKEN')
      }
      let loadingTask = pdfjsLib.getDocument({
        url: src,
        httpHeaders: { 'X-XSRF-TOKEN': xsrft },
        withCredentials: true // 允許攜帶cookie
      })
      this.lastFinishUrl = src
      vm.fetchPDFByLoadingTask(loadingTask)
    },
    fetchPDFb64 (base64) {
      let decodedBase64 = atob(base64)
      const vm = this
      if (vm.usedMaskLoading) { // 透過旗標決定是否要有等候遮罩畫面
        vm.startLoading()
      }
      let xsrft = getCookie('!Proxy!RestApiProxyXSRF-TOKEN')
      if (!xsrft) {
        xsrft = getCookie('XSRF-TOKEN')
      }
      let loadingTask = pdfjsLib.getDocument({
        data: decodedBase64,
        httpHeaders: { 'X-XSRF-TOKEN': xsrft },
        withCredentials: true // 允許攜帶cookie
      })
      vm.fetchPDFByLoadingTask(loadingTask)
      if (vm.usedMaskLoading) {
        vm.endLoading()
      }
    },
    fetchPDFByLoadingTask (loadingTask) {
      const vm = this

      loadingTask.promise.then(function (pdfDoc) {
        // 處理之前遺留的物件，避免記憶體洩漏問題
        let oldPdfDoc = vm.pdfDoc
        if (oldPdfDoc && oldPdfDoc.cleanup) {
          oldPdfDoc.cleanup()
          oldPdfDoc.destroy()
        }
        vm.pdfDoc = pdfDoc
        let pageCount = pdfDoc.numPages
        vm.numPages = pageCount
        const canvasContainer = vm.$refs['canvasContainer']
        canvasContainer.innerHTML = ''
        let tasks = []
        for (let index = 1; index <= pageCount; index++) {
          // --依照順序產生圖片物件
          const newImg = document.createElement('img')
          canvasContainer.appendChild(newImg)
          const canvas = document.createElement('canvas')
          tasks.push(vm.renderPage(index, newImg, canvas))
        }
        Promise.all(tasks).then(() => {
          if (vm.usedMaskLoading) {
            vm.endLoading()
          }
          loadingTask.destroy()
        }).catch((e) => {
          //alert(e)
          console.log('pdfjsLib error - Promise')
          if (vm.usedMaskLoading) {
            vm.endLoading()
          }
          console.log(e)
        })
      }).catch(() => {
        console.log('pdfjsLib error - loadingTask')
        if (vm.usedMaskLoading) {
          vm.endLoading()
        }
        console.log(e)
        vm.$alert('文件產出發生異常，請聯絡系統管理員。', () => {
          window.location.reload()
        })
      })
    },
    renderPage (num, newImg, canvas) {
      let vm = this
      const getPagePromise = this.pdfDoc.getPage(num).then(function (pdfPage) {
        const canvasContext = canvas.getContext('2d')
        const dpr = window.devicePixelRatio || 1
        const bsr =
          canvasContext.webkitBackingStorePixelRatio ||
          canvasContext.mozBackingStorePixelRatio ||
          canvasContext.msBackingStorePixelRatio ||
          canvasContext.oBackingStorePixelRatio ||
          canvasContext.backingStorePixelRatio ||
          1
        let ratio = dpr / bsr
        if (vm.cfgRatio) { // 客製化比例定義
          ratio = parseFloat(vm.cfgRatio)
        }
        ratio = ratio * CSS_UNITS
        const viewport = pdfPage.getViewport({ scale: ratio })
        const { width, height } = viewport
        canvas.width = width
        canvas.height = height
        if (!vm.stretch) {
          canvas.style.width = `${width}px`
          canvas.style.height = `${height}px`
        } else {
          canvas.style.width = '100%'
          canvas.style.height = '100%'
        }
        const renderContext = {
          canvasContext,
          viewport
        }
        // console.log('num=' + num)
        // outRefPdfPage = pdfPage
        var renderTask = pdfPage.render(renderContext)
        return renderTask.promise.then(() => {
          const canvasContext = canvas.getContext('2d')
          canvas.toBlob(function (blob) {
            var url = window.URL.createObjectURL(blob)
            newImg.src = url
            // 清除畫布
            canvasContext.clearRect(0, 0, canvas.width, canvas.height)
            // console.log('toBlob_num=' + num)
            pdfPage.cleanup()
            pdfPage._destroy()
            pdfPage = null
          })
        })
      })
      return getPagePromise
    }

  },
  beforeDestroy () {
    // console.log(this.$refs)
    const { pdfDoc } = this
    if (pdfDoc && pdfDoc.cleanup && pdfDoc.destroy) {
      // pdfDoc.cleanup() //之前已經 cleanup 此處會有錯誤發生
      pdfDoc.destroy()
    }
    // pdfDoc && pdfDoc.cleanup()
    // pdfDoc && pdfDoc.destroy()
  }

}
</script>

<style lang="stylus" scoped>
</style>
